function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M197.6 104.7l-23.8 23.9.3 126.3h-64.4l-.2-61.7L81 221.9l.1 61.6h121.5l-.4-160.3c.2-6.5-1.5-12.8-4.6-18.5zM109.4 123.2c0-5.4 4.4-9.7 9.7-9.7h14.3v-85h16.4v83.9l28.5-28.7V0h-73.5v87.7c-14.5 5.8-24 19.9-24 35.5l.1 58.4 28.5-28.6v-29.8zM9.349 262.183L263.939 7.378l10.256 10.248L19.606 272.432z"
})));